import { useState, useEffect } from 'preact/hooks';
import _ from 'lodash';
export const SCREEN_SIZES = {
  MOBILE: 'MOBILE',
  TABLET: 'TABLET',
  DESKTOP: 'DESKTOP',
};
const SCREEN_BREAKPOINTS = {
  [SCREEN_SIZES.MOBILE]: 0,
  [SCREEN_SIZES.TABLET]: 768,
  [SCREEN_SIZES.DESKTOP]: 1232,
};
export function useScreenSize() {
  const [screenSize, setScreenSize] = useState(_buildScreenSize());
  
  useEffect(() => {
    const handleResize = _.debounce(() => {
      setScreenSize(_buildScreenSize());
    }, 100);
    window.addEventListener('resize', handleResize);
    return () => {
      handleResize.cancel();
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return screenSize;
}
function _buildScreenSize() {
  let namedSize = SCREEN_SIZES.MOBILE;
  _.forEach(SCREEN_BREAKPOINTS, (breakpointWidth, breakpointName) => {
    if (window.innerWidth >= breakpointWidth) {
      namedSize = breakpointName;
    }
  });
  return {
    screenSize: namedSize,
    screenWidth: window.innerWidth || 0,
    screenHeight: window.innerHeight || 0,
  };
}
